import * as React from "react";
import { useState, useEffect } from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import Slide from "@mui/material/Slide";
import TextField from "@mui/material/TextField";
import { doc, updateDoc, deleteDoc } from "firebase/firestore";
import { db } from "../../firebase";

import "./modal.css";

const Transition = React.forwardRef(function Transition(props, ref) {
	return <Slide direction="up" ref={ref} {...props} />;
});

export default function UserModal({
	open,
	handleClose,
	user,
	type,
	fetchUsers,
}) {
	const inputs = [
		{
			lable: "Баланс",
			dataType: "number",
			name: "balance",
			type: "input",
			block: "Базовая информация",
		},
		{
			lable: "Депозиты",
			dataType: "number",
			name: "deposits",
			type: "input",
			block: "Базовая информация",
		},
		{
			lable: "Прибыльные сделки",
			dataType: "number",
			name: "profitableTrades",
			type: "input",
			block: "Трейдинг",
		},
		{
			lable: "Убыточные сделки",
			dataType: "number",
			name: "unprofitableTrades",
			type: "input",
			block: "Трейдинг",
		},
		{
			lable: "Всего инвестировано",
			dataType: "number",
			name: "invested",
			type: "input",
			block: "Трейдинг",
		},
		{
			lable: "PNL",
			dataType: "number",
			name: "pnl",
			type: "input",
			block: "Трейдинг",
		},
		{
			lable: "Средний % инвестиций",
			dataType: "number",
			name: "averageInvestment",
			type: "input",
			block: "Трейдинг",
		},
		{
			lable: "Покупки",
			dataType: "number",
			name: "orders",
			type: "input",
			block: "График Баланса",
		},
		{
			lable: "Число покупки (день числом)",
			dataType: "number",
			name: "orderDay",
			type: "input",
			block: "График Баланса",
		},
		{
			lable: "Выводы",
			dataType: "number",
			name: "withdrawals",
			type: "input",
			block: "График Баланса",
		},
		{
			lable: "Число вывода (день числом)",
			dataType: "number",
			name: "withdrawalDay",
			type: "input",
			block: "График Баланса",
		},
		{
			lable: "Депозиты",
			dataType: "number",
			name: "chartDeposits",
			type: "input",
			block: "График Баланса",
		},
		{
			lable: "Число депозита (день числом)",
			dataType: "number",
			name: "depositsDay",
			type: "input",
			block: "График Баланса",
		},
		{
			lable: "Обмены",
			dataType: "number",
			name: "exchanges",
			type: "input",
			block: "График Баланса",
		},
		{
			lable: "Число обмена (день числом)",
			dataType: "number",
			name: "exchangesDay",
			type: "input",
			block: "График Баланса",
		},
	];
	const [inputsValues, setInputsValues] = useState({
		balance: 0,
		deposits: 0,
		profitableTrades: 0,
		unprofitableTrades: 0,
		orders: 0,
		orderDay: 0,
		withdrawals: 0,
		withdrawalDay: 0,
		chartDeposits: 0,
		depositsDay: 0,
		exchanges: 0,
		exchangesDay: 0,
		invested: 0,
		pnl: 0,
		averageInvestment: 0,
	});
	useEffect(() => {
		setInputsValues({
			balance: user.balance || 0,
			deposits: user.deposits || 0,
			profitableTrades: user.profitableTrades || 0,
			unprofitableTrades: user.unprofitableTrades || 0,
			orders: user.orders || 0,
			orderDay: user.orderDay || 0,
			withdrawals: user.withdrawals || 0,
			withdrawalDay: user.withdrawalDay || 0,
			chartDeposits: user.chartDeposits || 0,
			depositsDay: user.depositsDay || 0,
			exchanges: user.exchanges || 0,
			exchangesDay: user.exchangesDay || 0,
			invested: user.invested || 0,
			pnl: user.pnl || 0,
			averageInvestment: user.averageInvestment || 0,
		});
	}, [user]);
	const handleChange = (e) => {
		const { name, value } = e.target;
		setInputsValues({
			...inputsValues,
			[name]: +value,
		});
	};
	const handleUpdateUser = async () => {
		try {
			const userRef = doc(db, "users", user.id); // user.id — это ID документа Firestore
			await updateDoc(userRef, inputsValues);
			alert("Данные успешно обновлены!");
			handleClose(); // Закрыть модальное окно
			fetchUsers();
		} catch (error) {
			console.error("Ошибка обновления данных:", error);
			alert("Не удалось обновить данные пользователя.");
		}
	};
	const handleDeleteUser = async () => {
		try {
			const userRef = doc(db, "users", user.id); // user.id — это ID документа Firestore
			await deleteDoc(userRef);
			alert("Пользователь успешно удалён!");

			// Обновить состояние users
			fetchUsers();

			handleClose(); // Закрыть модальное окно
		} catch (error) {
			console.error("Ошибка удаления пользователя:", error);
			alert("Не удалось удалить пользователя.");
		}
	};
	return (
		<Dialog
			open={open}
			TransitionComponent={Transition}
			keepMounted
			onClose={handleClose}
			aria-describedby="alert-dialog-slide-description"
		>
			<DialogTitle className="modal-title">
				{type === "delete"
					? `Удаление пользователя ${user.name} ${user.surname}`
					: `Редактирование пользователя ${user.name} ${user.surname}`}
			</DialogTitle>
			<DialogContent>
				<div className="modal-block-wrapper">
					{type === "delete" ? (
						<div className="modal-title">
							Вы уверены что хотите удалить пользователя {user.name} {user.surname}?
						</div>
					) : (
						Object.entries(
							inputs.reduce((acc, input) => {
								if (!acc[input.block]) {
									acc[input.block] = [];
								}
								acc[input.block].push(input);
								return acc;
							}, {})
						).map(([block, inputs]) => (
							<div key={block} className="modal-block">
								<div className="modal-block-title">{block}</div>
								{inputs.map((input) => (
									<TextField
										key={input.name}
										label={input.lable}
										name={input.name}
										type={input.type}
										value={inputsValues[input.name]}
										onChange={handleChange}
										sx={{
											width: 175,
										}}
									/>
								))}
							</div>
						))
					)}
				</div>
			</DialogContent>
			<DialogActions>
				<Button onClick={handleClose} color="error" variant="outlined">
					Отменить
				</Button>
				<Button
					color="success"
					variant="outlined"
					onClick={type === "delete" ? handleDeleteUser : handleUpdateUser}
				>
					Подтвердить
				</Button>
			</DialogActions>
		</Dialog>
	);
}
